export default function lowercaseInitials(
  str: string,
  separator: string | RegExp = /(\s|-)/,
  joinWithWhitespace = false,
) {
  return str
    .split(separator)
    .map((s) => s.charAt(0).toLowerCase() + s.slice(1))
    .join(joinWithWhitespace ? " " : "");
}
